/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_ExportingInputs */

const vi_movement_breakdown_exporting = /** @type {(inputs: Movement_Breakdown_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang xuất…`)
};

/**

* @param {Movement_Breakdown_ExportingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_exporting = /** @type {((inputs?: Movement_Breakdown_ExportingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_ExportingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_exporting(inputs)
});